'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var ItemContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  margin-bottom: 26px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  margin-bottom: 26px;\n"])));
var QuantityContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  width: 24px;\n  height: 26px;\n  border-radius: 2px;\n  flex: 0 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 22px;\n  font: 400 14px/16px ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n  width: 24px;\n  height: 26px;\n  border-radius: 2px;\n  flex: 0 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 22px;\n  font: 400 14px/16px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var PriceContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  flex: 0 1 auto;\n"], ["\n  flex: 0 1 auto;\n"])));
var Text = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: normal 16px/19px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n"], ["\n  font: normal 16px/19px ", ";\n  color: ", ";\n  overflow-wrap: break-word;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Price = styled__default(Text)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var TitleText = Text;
var SubtitleText = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: italic 12px/14px ", ";\n  color: ", ";\n"], ["\n  font: italic 12px/14px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var TextContainer = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.ItemContainer = ItemContainer;
exports.Price = Price;
exports.PriceContainer = PriceContainer;
exports.QuantityContainer = QuantityContainer;
exports.SubtitleText = SubtitleText;
exports.TextContainer = TextContainer;
exports.TitleText = TitleText;
